import * as React from "react";
import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "#746A80"}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="m14.354 4.854-8 8a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 0 1 .708-.708L6 11.793l7.646-7.647a.5.5 0 0 1 .708.708"
    />
  </svg>
);
export default SvgCheck;
